<template>
  <TCombobox
    v-model="brand"
    :options="options"
    :placeholder="t('placeholder')"
  />
</template>

<script setup lang="ts">
import { RV_MANUFACTURERS } from '~/constants/manufacturers'

const brand = defineModel<string>({ default: '' })

const { t } = useI18n()

const options = computed(() => {
  return RV_MANUFACTURERS.map((option) => ({ label: option, value: option }))
})
</script>

<i18n lang="json">
{
  "en": {
    "placeholder": "Ex: “Thor” or “Coachmen”"
  },
  "fr": {
    "placeholder": "Exemple: “Thor” ou “Coachmen”"
  }
}
</i18n>
